import { Grid } from "antd-mobile";
import styles from "./styleModule";

const PersonalMenu = ({
  menuItems = [],
  columns = 0,
  menuItemContainerStyle = "",
  customMenuTitleStyle = "",
  customTitleStyle = "",
  customMenuContainerStyle = "",
  menuGap = [0, 0],
}) => {
  return (
    <div className={`${styles.menuContainer} ${customMenuContainerStyle}`}>
      <Grid columns={columns} gap={menuGap}>
        {menuItems.map((item) => {
          return (
            <Grid.Item key={item.title}>
              <div
                className={`${styles.itemContainer} ${menuItemContainerStyle}`}
                onClick={item.onClick}
                style={{ backgroundColor: item.backgroundColor }}
              >
                {item.icon}
                <div className={`${styles.menuTitle} ${customMenuTitleStyle}`}>
                  <div className={`${styles.title} ${customTitleStyle}`}>{item.title}</div>
                </div>
              </div>
            </Grid.Item>
          );
        })}
      </Grid>
    </div>
  );
};

export default PersonalMenu;
